<div class="row page-header">
    <div class="col-12">
        <h1>Roles/Rights <small>Configure roles for users and the rights that belong to each role</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Roles and Rights</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Rights Report</a>
        </li>
    </ul>

    <div class="row" [hidden]="active !== 1">
        <div class="col-lg-6">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="rolesGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="rolesGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="rolesGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="rolesGrid.initialize(mainGrid)"
                        (destroy)="rolesGrid.destroy()"
                        [itemsSource]="rolesGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="rightsGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="rightsGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="childGrid"
                        #childGrid
                        appAutoSize
                        (initialized)="rightsGrid.initialize(childGrid)"
                        (destroy)="rightsGrid.destroy()"
                        [itemsSource]="rightsGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [hidden]="active !== 2">
        <div class="col-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="reportGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="reportGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridReport"
                        #gridReport
                        appAutoSize
                        (initialized)="reportGrid.initialize(gridReport)"
                        (destroy)="reportGrid.destroy()"
                        [itemsSource]="reportGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Right'" [binding]="'right'" [width]="300"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Users'" [binding]="'userNames'" [width]="'*'">
                            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                                <div [title]="cell.item.userNames">
                                    {{ cell.item.userNames }}
                                </div>
                            </ng-template>
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
